// Local Partner type (kept here to avoid circular imports)
export type Partner = {
  id: number;
  name: string;
  logo: string;
  isHighProfile?: boolean;
  needsLargerImage?: boolean;
};

// Resolve asset URLs via import.meta.url so they bundle correctly
const gianniImage = new URL("../../assets/ec5db0526bf4fd60f397d4a39af44ed45f40c38d.png", import.meta.url).toString();
const worldBankImage = new URL("../../assets/532fa75b90e10363ce13adb2920efb1912d1c497.png", import.meta.url).toString();
const confagricolturaImage = new URL("../../assets/701403fd084b0f4cc8b08696618811339606a278.png", import.meta.url).toString();
const croceRossaImage = new URL("../../assets/52501d404f783ff859fc4cba95cbe49ecccc035c.png", import.meta.url).toString();
const finecoImage = new URL("../../assets/34455479216ebc8b71bc2434ed1a6e64b93ab60a.png", import.meta.url).toString();

const johnsonImage = new URL("../../assets/89a0785058b84dec3dcd185cce3cd342f68618e8.png", import.meta.url).toString();
const legambienteImage = new URL("../../assets/86642085a6acaa592b9eec07a23e2b5ed423d94f.png", import.meta.url).toString();
const gameStopImage = new URL("../../assets/6890318d35deb5f71725860536870bbfede6dd9f.png", import.meta.url).toString();
const saveTheChildrenImage = new URL("../../assets/09c5c5bd39c4caf78000de504356f95f2e15ef05.png", import.meta.url).toString();
const trenitalia = new URL("../../assets/d87f918f3b136f1515385ee3f076877fd2f2bd25.png", import.meta.url).toString();

export const PARTNERS_DATA: Partner[] = [
  {
    id: 1,
    name: "Save the Children",
    logo: saveTheChildrenImage,
    isHighProfile: true,
    needsLargerImage: true,
  },
  {
    id: 2,
    name: "Confagricoltura",
    logo: confagricolturaImage,
    isHighProfile: false,
    needsLargerImage: true,
  },
  {
    id: 3,
    name: "Croce Rossa Italiana",
    logo: croceRossaImage,
    isHighProfile: true,
    needsLargerImage: true,
  },
  {
    id: 4,
    name: "World Bank Group",
    logo: worldBankImage,
    isHighProfile: true,
    needsLargerImage: true,
  },
  {
    id: 5,
    name: "Legambiente",
    logo: legambienteImage,
    isHighProfile: true,
    needsLargerImage: true,
  },
  {
    id: 6,
    name: "Trenitalia",
    logo: trenitalia,
    isHighProfile: true,
    needsLargerImage: true,
  },
  {
    id: 7,
    name: "Giannini Automobili",
    logo: gianniImage,
    isHighProfile: false,
    needsLargerImage: true,
  },
  {
    id: 8,
    name: "GameStop",
    logo: gameStopImage,
    isHighProfile: true,
    needsLargerImage: true,
  },
  {
    id: 11,
    name: "Fineco Bank",
    logo: finecoImage,
    isHighProfile: true,
    needsLargerImage: true,
  },
  {
    id: 12,
    name: "Johnson Health Tech",
    logo: johnsonImage,
    isHighProfile: true,
    needsLargerImage: true,
  },
];

export const PARTNERS_SECTION = {
  TITLE: "Ci Hanno Scelto",
  SUBTITLE:
    "Alcuni dei nostri clienti: garantiamo servizi di qualità superiore e soluzioni innovative per ogni tipo di business e struttura nella provincia di Roma.",
  FOOTER_TEXT:
    "E molti altri clienti soddisfatti!",
  ANIMATION_DURATION: "50s",
  CONTAINER_GAP: "4rem",
  MOBILE_CONTAINER_GAP: "3rem",
} as const;

export const PARTNERS_STYLING = {
  LOGO_SIZE_DESKTOP: {
    WIDTH: "5.5rem",
    HEIGHT: "5.5rem",
  },
  LOGO_SIZE_MOBILE: {
    WIDTH: "4.5rem",
    HEIGHT: "4.5rem",
  },
  PARTNER_MIN_WIDTH_DESKTOP: "140px",
  PARTNER_MIN_WIDTH_MOBILE: "120px",
  ENLARGED_SCALE_DESKTOP: "1.4",
  ENLARGED_SCALE_MOBILE: "1.4",
  HOVER_SCALE: "1.05",
} as const;